import React from "react";
import styles from "./ProjectSeparator.module.scss";

const ProjectSeparator = () => (
  <div className={styles.line}>
    <div className={styles.triangle} />
  </div>
);

export default ProjectSeparator;
